module.exports = __webpack_public_path__ + "static/media/13.68a3603c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/13.png
// module id = 695
// module chunks = 0